import { useEffect, useState } from "react";
import { toast } from "sonner";
import axiosInstance from "../Axios";
import DashboardUsersTable from "./DashboardUsersTable";
import useAuth from "../contexts/UserContext.tsx";
import { useNavigate } from "react-router-dom";

export default function DashboardUsers() {
  const [dashboardUsers, setDashboardUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  useEffect(() => {
    if (user.user_type !== "admin") {
      return navigate("/");
    }
    setLoading(true);
    axiosInstance
      .get(`/getDashBoardUser?auth_token=${user.auth_token}`)
      .then((res) => {
        if (res.data.data.message === "Invalid User") {
          toast.error("Invalid User");
          logout();
          return;
        }
        setDashboardUsers(res.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.user_type, navigate]);
  return (
    <div className="container">
      <DashboardUsersTable data={dashboardUsers} loading={loading} />
      <div className="flex justify-center mt-2"></div>
    </div>
  );
}
